"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeDataPropsInterface = void 0;

var _react = require("react");

var UpgradeProducts = _interopRequireWildcard(require("self-service-api/constants/UpgradeProducts"));

var upgradeDataPropsInterface = {
  upgradeData: _react.PropTypes.shape({
    app: _react.PropTypes.string,
    screen: _react.PropTypes.string,
    upgradeProduct: _react.PropTypes.oneOf(Object.values(UpgradeProducts))
  })
};
exports.upgradeDataPropsInterface = upgradeDataPropsInterface;